import React from "react";
import {
  InnerNavigationContainer,
  LeftNavigationWrapper,
  LogoContainer,
  NavigationLinksWrapper,
  Navigationlogo,
} from "./styled";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import Collapse from "react-collapse";
import logo from "../../../img/logo-light.png";

import "./style.scss";

const DashboardLeftNavigation = (props) => {
  const activePage = useSelector(
    (state) => state && state.activePage && state.activePage.activePage
  );
  const activeChild = useSelector(
    (state) => state.activePage && state.activePage.activeChild
  );

  const companyLoading = useSelector(
    (state) => state && state.activeCompany && state.activeCompany.loading
  );
  const company = useSelector(
    (state) => state && state.activeCompany && state.activeCompany.activeCompany
  );

  const navigatePage = (destination) => {
    switch (destination) {
      case "overview":
        props.history.push("/dashboard/oversikt");
        break;
      case "lists":
        props.history.push("/dashboard/lister");
        break;
      case "clients":
        props.history.push("/dashboard/kunder");
        break;
      case "messages":
        props.history.push("/dashboard/samtaler");
        break;
      case "pipeline":
        props.history.push("/dashboard/pipeline");
        break;
      case "deliveries":
        props.history.push("/dashboard/leveranser");
        break;
      case "channels":
        props.history.push("/dashboard/kanaler");
        break;
      case "campaigns":
        props.history.push("/dashboard/utsendelser");
        break;
      case "library":
        props.history.push("/dashboard/bibliotek");
        break;
      case "contact-lists":
        props.history.push("/dashboard/kontaktlister");
        break;
      case "email-templates":
        props.history.push("/dashboard/maler");
        break;
      case "company":
        props.history.push("/dashboard/foretak#team");
        break;
      case "helpcenter":
        props.history.push("/dashboard/hjelpesenter");
        break;
      default:
        break;
    }
  };

  const renderRootPageDisplay = (target) => {
    if (activePage === target) {
      if (!companyLoading) {
        if (company && company.subscription) {
          return `root-menu-button w-100 d-block pt-2 pb-2 active`;
        } else {
          return `root-menu-buttonw-100 d-block invalid pt-2 pb-2`;
        }
      } else {
        return `root-menu-button w-100 d-block pt-2 pb-2`;
      }
    } else {
      if (!companyLoading) {
        if (company && company.subscription) {
          return `root-menu-button w-100 d-block pt-2 pb-2`;
        } else {
          return `root-menu-button w-100 invalid d-block pt-2 pb-2`;
        }
      } else {
        return `root-menu-button w-100 d-block pt-2 pb-2`;
      }
    }
  };

  const renderChildDisplay = (target) => {
    if (activeChild === target) {
      if (!companyLoading) {
        if (company && company.subscription) {
          return `sub-menu-button w-100 d-block pt-2 pb-2 active`;
        } else {
          return `sub-menu-buttonw-100 d-block invalid pt-2 pb-2`;
        }
      } else {
        return `sub-menu-button w-100 d-block pt-2 pb-2`;
      }
    } else {
      if (!companyLoading) {
        if (company && company.subscription) {
          return `sub-menu-button w-100 d-block pt-2 pb-2`;
        } else {
          return `sub-menu-button w-100 invalid d-block pt-2 pb-2`;
        }
      } else {
        return `sub-menu-button w-100 d-block pt-2 pb-2`;
      }
    }
  };

  const determineCampaignsToggled = () => {
    if (activePage === "campaigns") {
      return true;
    } else {
      return false;
    }
  };

  return (
    <section className="dashboard-left-navigation-section">
      <div className="inner-dashboard-left-container">
        <div className="logo-container">
          <img alt="Leadfind logo" className="logo" src={logo} />
        </div>
        <div className="links-container">
          <div className="single-option-container">
            <div onClick={() => navigatePage("overview")}>
              <button
                className={
                  activePage === "overview"
                    ? "root-menu-button w-100 d-block pt-2 pb-2 active"
                    : "root-menu-button w-100 d-block pt-2 pb-2"
                }
              >
                <i class="fad fa-columns"></i> Oversikt{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
          </div>
          <div className="single-option-container">
            <div
              data-tip={`${
                !companyLoading && company && !company.subscription
                  ? "Du har ikke tilgang til denne siden."
                  : ""
              }`}
              onClick={
                company && company.subscription
                  ? () => navigatePage("lists")
                  : null
              }
            >
              <button className={renderRootPageDisplay("lists", "root")}>
                <i class="fad fa-stream"></i> Lister{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
          </div>
          <div className="single-option-container">
            <div
              data-tip={`${
                !companyLoading && company && !company.subscription
                  ? "Du har ikke tilgang til denne siden."
                  : ""
              }`}
              onClick={
                company && company.subscription
                  ? () => navigatePage("clients")
                  : null
              }
            >
              <button className={renderRootPageDisplay("clients", "root")}>
                <i class="fad fa-users"></i> Kunder{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
          </div>
          <div className="single-option-container">
            <div
              data-tip={`${
                !companyLoading && company && !company.subscription
                  ? "Du har ikke tilgang til denne siden."
                  : ""
              }`}
              onClick={
                company && company.subscription
                  ? () => navigatePage("campaigns")
                  : null
              }
            >
              <button className={renderRootPageDisplay("campaigns", "root")}>
                <i class="fas fa-lasso"></i> Utsendelser{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
            <Collapse isOpened={determineCampaignsToggled()}>
              <div className="collapsed-dropdown-container">
                <div
                  data-tip={`${
                    !companyLoading && company && !company.subscription
                      ? "Du har ikke tilgang til denne siden."
                      : ""
                  }`}
                  onClick={
                    company && company.subscription
                      ? () => navigatePage("campaigns")
                      : null
                  }
                >
                  <button className={renderChildDisplay("campaigns")}>
                    <i class="fad fa-circle circle"></i> Utsendelser{" "}
                    <i className="right-arrow fas fa-angle-right"></i>
                  </button>
                </div>
                <div
                  data-tip={`${
                    !companyLoading && company && !company.subscription
                      ? "Du har ikke tilgang til denne siden."
                      : ""
                  }`}
                  onClick={
                    company && company.subscription
                      ? () => navigatePage("contact-lists")
                      : null
                  }
                >
                  <button className={renderChildDisplay("contact-lists")}>
                    <i class="fad fa-circle circle"></i> Kontaktlister{" "}
                    <i className="right-arrow fas fa-angle-right"></i>
                  </button>
                </div>
                <div
                  data-tip={`${
                    !companyLoading && company && !company.subscription
                      ? "Du har ikke tilgang til denne siden."
                      : ""
                  }`}
                  onClick={
                    company && company.subscription
                      ? () => navigatePage("email-templates")
                      : null
                  }
                >
                  <button className={renderChildDisplay("email-templates")}>
                    <i class="fad fa-circle circle"></i> Maler{" "}
                    <i className="right-arrow fas fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </Collapse>
          </div>
          {false && (
            <>
              <div className="single-option-container">
                <div
                  data-tip={`${
                    !companyLoading && company && !company.subscription
                      ? "Du har ikke tilgang til denne siden."
                      : ""
                  }`}
                  onClick={
                    company && company.subscription
                      ? () => navigatePage("channels")
                      : null
                  }
                >
                  <button className={renderRootPageDisplay("channels", "root")}>
                    <i class="fa-duotone fa-signature-lock"></i> Telefonsentral{" "}
                    <i className="right-arrow fas fa-angle-right"></i>
                  </button>
                </div>
              </div>
              <div className="single-option-container">
                <div
                  data-tip={`${
                    !companyLoading && company && !company.subscription
                      ? "Du har ikke tilgang til denne siden."
                      : ""
                  }`}
                  onClick={
                    company && company.subscription
                      ? () => navigatePage("channels")
                      : null
                  }
                >
                  <button className={renderRootPageDisplay("channels", "root")}>
                    <i class="fa-duotone fa-signature-lock"></i> Avtaler{" "}
                    <i className="right-arrow fas fa-angle-right"></i>
                  </button>
                </div>
              </div>
            </>
          )}
          <div className="single-option-container">
            <div
              data-tip={`${
                !companyLoading && company && !company.subscription
                  ? "Du har ikke tilgang til denne siden."
                  : ""
              }`}
              onClick={
                company && company.subscription
                  ? () => navigatePage("pipeline")
                  : null
              }
            >
              <button className={renderRootPageDisplay("pipeline", "root")}>
                <i className="fas fa-filter"></i> Pipeline{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
          </div>
          {false && (
            <div
              data-tip={`${
                !companyLoading && company && !company.subscription
                  ? "Du har ikke tilgang til denne siden."
                  : ""
              }`}
              onClick={
                company && company.subscription
                  ? () => navigatePage("deliveries")
                  : null
              }
            >
              <button className={renderRootPageDisplay("deliveries")}>
                <i class="fad fa-box-full"></i> Leveranser{" "}
                <span className="badge">Nytt</span>{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
          )}
          <div className="single-option-container">
            <div
              data-tip={`${
                !companyLoading && company && !company.subscription
                  ? "Du har ikke tilgang til denne siden."
                  : ""
              }`}
              onClick={
                company && company.subscription
                  ? () => navigatePage("library")
                  : null
              }
            >
              <button className={renderRootPageDisplay("library", null)}>
                <i class="fad fa-folder-open"></i> Bibliotek{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
          </div>
          {!companyLoading && company && company.admin && (
            <div className="single-option-container">
              <div onClick={() => navigatePage("company")}>
                <button
                  className={
                    activePage === "company"
                      ? "root-menu-button w-100 d-block pt-2 pb-2 active"
                      : "root-menu-button w-100 d-block pt-2 pb-2"
                  }
                >
                  <i class="fad fa-building"></i> Mitt Foretak{" "}
                  <i className="right-arrow fas fa-angle-right"></i>
                </button>
              </div>
            </div>
          )}
          <hr />
          <div className="single-option-container">
            <div
              data-tip={`${
                !companyLoading && company && !company.subscription
                  ? "Du har ikke tilgang til denne siden."
                  : ""
              }`}
              onClick={
                company && company.subscription
                  ? () => navigatePage("helpcenter")
                  : null
              }
            >
              <button className={renderRootPageDisplay("helpcenter", "root")}>
                <i class="far fa-life-ring"></i> Hjelpesenter{" "}
                <i className="right-arrow fas fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withRouter(DashboardLeftNavigation);
